import { Component, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoService } from '@ngneat/transloco';
import { filter, skip } from 'rxjs/operators';
import { HostLanguageChangeEvent } from './core/microfrontends/routing/language-events.model';
import { HostOuChangeEvent } from './core/microfrontends/routing/ou-events.model';
import { OrganizationalUnitService } from './modules/shared/services/organizational-unit.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Humanage';
  private readonly transloco = inject(TranslocoService);
  private readonly organizationalUnitService = inject(OrganizationalUnitService);

  constructor() {
    this.transloco.langChanges$
      .pipe(takeUntilDestroyed())
      .subscribe(lang => {
        globalThis.dispatchEvent(new HostLanguageChangeEvent({
          lang,
          timestamp: Date.now(),
        }));
      });

    this.organizationalUnitService.getCurrentOu$()
      .pipe(skip(1), filter(Boolean), takeUntilDestroyed())
      .subscribe(ou => {
        globalThis.dispatchEvent(new HostOuChangeEvent({
          ou,
          timestamp: Date.now(),
        }));
      });
  }

  ngOnInit(): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).pdfWorkerSrc = 'assets/js/pdf.worker.mjs';
  }
}
